/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { MessageFactoryProvider } from '../provider/message-factory.provider';

export class MessageService {

  getMessage(source: any): string {
    const messageFactory = MessageFactoryProvider.resolveMessageFactory(source);
    return messageFactory ? messageFactory.getMessage(source) : JSON.stringify(source);
  }

}
